import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import dayjs from "dayjs";
import { SERVICE_EVALUATION_POPUP } from "@/types";
import { useRoute } from "vue-router";

const __default__ = {
  name: "SurveyNoticeModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onClose", "onClickSurveyNow"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

const emit = __emit;

const route = useRoute();
const showSurveyModal = ref(true);

const onClickNoMoreShowForThreeDays = () => {
  setCookie(SERVICE_EVALUATION_POPUP);
  onClickClose();
};

const onClickClose = () => {
  route.meta.onBackHandlerList.pop();
  showSurveyModal.value = false;
  setTimeout(() => {
    emit("onClose");
  }, 300);
};

const goToSurvey = () => {
  showSurveyModal.value = false;
  setTimeout(() => {
    emit("onClose");
    emit("onClickSurveyNow");
  }, 300);
};

const setCookie = (key: string) => {
  const nowDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
  const expireDate = dayjs()
    .add(2, "day")
    .set("hour", 23)
    .set("minute", 59)
    .set("second", 59)
    .utc()
    .format("ddd, D MMM YYYY HH:mm:ss UTC");
  document.cookie = `${key}=${nowDate}; expires=${expireDate}; path=/`;
};

onMounted(() => {
  route.meta.onBackHandlerList.push(onClickClose);
});

const __returned__ = { utc, emit, route, showSurveyModal, onClickNoMoreShowForThreeDays, onClickClose, goToSurvey, setCookie }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})